{
  "0_ALREADY_EXISTS": "\"{0}\" มีอยู่แล้ว",
  "0_OF_1": "{0} ของ {1}",
  "ACCOUNT_ID": "รหัสบัญชี",
  "ADD": "เพิ่ม",
  "ADD_REMOVE_FIELDS": "เพิ่ม/ลบเขตข้อมูล",
  "AN_ERROR_OCCURED": "เกิดข้อผิดพลาด",
  "APPLY": "ใช้",
  "APPLY_CHANGES": "ใช้การเปลี่ยนแปลง",
  "ATTACH": "ติด",
  "ATTACH_AS_LINK": "แนบเป็นลิงค์",
  "ATTACHING": "แนบ   ",
  "AUTOMATICALLY_RENAME": "เปลี่ยนชื่อโดยอัตโนมัติ",
  "BACK": "ย้อนกลับ",
  "BROWSE": "เล็ม",
  "CANCEL": "ยกเลิก",
  "CHARACTER_COUNT": "จํานวนอักขระ:",
  "CLOSE": "ปิด",
  "CLOUD": "เมฆ",
  "COMMENT": "ติชม",
  "CONFIGURE_REPOSITORY_SETTINGS": "กําหนดการตั้งค่าที่เก็บ",
  "COULD_NOT_SAVE_0": "ไม่สามารถบันทึก \"{0}\".",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "ไม่สามารถบันทึก \"{0}\". ไม่รองรับประเภทไฟล์",
  "DATA": "ข้อมูล",
  "DATE": "วันที่",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "ฟิลด์วันที่ต้องอยู่ในรูปแบบ {0}.",
  "DATE_PROVIDED_IS_INVALID": "วันที่ที่ระบุไม่ถูกต้อง",
  "DATE_TIME": "วัน/เวลา",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "ฟิลด์วันที่/เวลาต้องอยู่ในรูปแบบ {0}.",
  "DEFAULT_FOLDER": "<โฟลเดอร์เริ่มต้น>",
  "DETAILS": "ราย ละเอียด",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "คุณต้องการใช้การเปลี่ยนแปลงฟิลด์ของคุณหรือไม่?",
  "DOCUMENT_NAME_IS_EMPTY": "ชื่อเอกสารว่างเปล่า",
  "DRAG_DROP_FILE": "ลากและวางไฟล์",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "รายการชื่อ '{0}' มีอยู่แล้วในโฟลเดอร์นี้ โปรดเลือกชื่ออื่น",
  "ENTRY_ID": "รหัสรายการ",
  "ENTRY_NAME": "ชื่อรายการ",
  "ENTRY_NOT_FOUND": "ไม่พบรายการ",
  "ERROR_DOWNLOADING_DOCUMENT": "ข้อผิดพลาดในการดาวน์โหลดเอกสาร",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "เกิดข้อผิดพลาดขณะเชื่อมต่อกับเซิร์ฟเวอร์",
  "ERROR_SAVING": "การบันทึกข้อผิดพลาด:",
  "FAILED_TO_OPEN_FOLDER": "เปิดโฟลเดอร์ไม่สําเร็จ",
  "FAILED_TO_SAVE_COLON": "บันทึกไม่สําเร็จ:",
  "FAILED_TO_SAVE_PERIOD": "บันทึกไม่สําเร็จ",
  "FEEDBACK": "การตอบสนอง",
  "FIELDS": "ฟิลด์",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "ไฟล์นี้เกินขนาดไฟล์สูงสุด 25MB",
  "FILE_EXTENSION": "นามสกุลไฟล์",
  "FILE_LOCKED": "ไฟล์ถูกล็อค",
  "FILE_MODIFIED": "แก้ไขไฟล์",
  "FILE_NAME": "ชื่อไฟล์",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "ชื่อไฟล์ต้องมีเครื่องหมายทับขวา",
  "FOLDER": "โฟลเดอร์",
  "INTEGER": "จํานวนเต็ม",
  "LIST": "รายการ",
  "LOADING": "การโหลด   ",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "ฟิลด์ยาวต้องเป็นจํานวนเต็มระหว่าง 0 ถึง 3,999,999,999",
  "LONG_INTEGER": "จํานวนเต็มยาว",
  "NAME": "ชื่อ",
  "NAME_CONFLICT": "ความขัดแย้งของชื่อ",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "ต้องการความช่วยเหลือในการลงชื่อเข้าใช้ใช่ไหม ติดต่อผู้ดูแลระบบ Laserfiche ของคุณเพื่อขอความช่วยเหลือ",
  "NEW_FOLDER": "โฟลเดอร์ใหม่",
  "NO": "ไม่ใช่",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "ไม่มีการกําหนดฟิลด์เพิ่มเติม",
  "NO_FOLDER_SELECTED": "ไม่มีการเลือกโฟลเดอร์",
  "NO_MATCHING_ENTRIES_FOUND": "ไม่พบรายการที่ตรงกัน",
  "NO_MATCHING_FIELDS_FOUND": "ไม่พบฟิลด์ที่ตรงกัน",
  "NO_TEMPLATE_ASSIGNED": "ไม่มีการกําหนดเทมเพลต",
  "NOT_AVAILABLE_WITH_TOKENS": "ไม่สามารถใช้ได้กับโทเค็น",
  "NUMBER": "เลข",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "ฟิลด์ตัวเลขต้องเป็นตัวเลขที่ถูกต้อง",
  "OK": "ตกลง, ได้",
  "ONE_OR_MORE_FIELDS_INVALID": "ฟิลด์อย่างน้อยหนึ่งฟิลด์ไม่ถูกต้อง",
  "OPEN": "เปิด",
  "OPEN_IN_LASERFICHE": "เปิดใน Laserfiche",
  "OPTIONAL": "เสริม",
  "OR": "หรือ",
  "PARENT_FIELD": "ฟิลด์หลัก",
  "PARENT_ID": "รหัสผู้ปกครอง",
  "PARENT_NAME": "ชื่อผู้ปกครอง",
  "PLEASE_SELECT_A_FOLDER": "โปรดเลือกโฟลเดอร์",
  "REASON_FOR_DOWNLOADING": "เหตุผลในการดาวน์โหลด",
  "REFRESH": "ฟื้นฟู",
  "REMOVE": "ถอด",
  "REMOVE_REPOSITORY": "ลบที่เก็บ?",
  "REPOSITORY": "เก็บ",
  "REPOSITORY_COUNT": "จํานวนที่เก็บ",
  "REPOSITORY_ID": "รหัสที่เก็บ",
  "REPOSITORY_NAME": "ชื่อที่เก็บ",
  "REQUIRED": "ต้องระบุ",
  "REQUIRED_FIELD_IS_EMPTY": "ช่องต้องกรอกว่างเปล่า",
  "SAVE_CHANGES": "บันทึกการเปลี่ยนแปลง",
  "SAVE_TO_LASERFICHE": "บันทึกไปที่ Laserfiche",
  "SAVED_TO_LASERFICHE": "บันทึกไว้ใน Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "บันทึกไว้ใน Laserfiche:",
  "SAVED_WITH_MISSING_METADATA": "บันทึกด้วยข้อมูลเมตาที่ขาดหายไป:",
  "SAVING": "การประหยัด   ",
  "SEARCH_FIELDS": "ช่องค้นหา",
  "SELECT": "เลือก",
  "SELECT_REASON": "เลือกเหตุผล",
  "SELF_HOSTED": "โฮสต์เอง",
  "SESSION_COUNT": "จํานวนเซสชัน",
  "SETTINGS": "การตั้งค่า",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "ฟิลด์สั้นต้องเป็นจํานวนเต็มระหว่าง 0 ถึง 64999",
  "SIGN_IN": "เข้าสู่ระบบ",
  "SIGN_IN_TO_LASERFICHE": "ลงชื่อเข้าใช้ Laserfiche",
  "SIGN_OUT": "ลงชื่อออก",
  "SIGNING_IN": "กําลังลงชื่อเข้าใช้...",
  "SIGNING_OUT": "กําลังออกจากระบบ...",
  "SKIP_THIS_FILE": "ข้ามไฟล์นี้",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "มีบางอย่างผิดพลาด โปรดลองอีกครั้งในภายหลัง",
  "SUBMIT": "ส่ง",
  "SUGGESTION": "ข้อเสนอแนะ",
  "TEMPLATE": "แม่ แบบ",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "โหลดเทมเพลตไม่สําเร็จ",
  "TEXT": "ข้อความ",
  "THANK_YOU_FOR_SUBMISSION": "ขอบคุณสําหรับการส่งของคุณ!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "ฟิลด์นี้มีความยาวสูงสุดที่อนุญาต {0} อักขระ ",
  "THIS_FOLDER_IS_EMPTY": "โฟลเดอร์นี้ว่างเปล่า",
  "TIME": "เวลา",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "ฟิลด์เวลาต้องอยู่ในรูปแบบ {0}.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "ไม่สามารถโหลดฟิลด์ทั้งหมดได้:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "ไม่สามารถดึงข้อมูลที่เก็บได้:",
  "UNKNOWN_ERROR": "ข้อผิดพลาดที่ไม่รู้จัก",
  "USER_NAME": "ชื่อผู้ใช้",
  "YES": "ใช่"
}
